/*
 * The Vitals underwear-set offer (docs/VITALS_SET_OFFER_SPEC.md). Vitals renders the offer and owns
 * its add and its discount; nothing here writes to the cart. This file does two things:
 *
 * - It reads what Vitals offers on each surface, so Complete your look leaves those pieces out:
 *   the set wins, because only Vitals' add carries the ฿200. A cart row names its partner's product
 *   id; the product page's box names its pieces only by title, which Vitals prints translated, as
 *   the look cards do. When that changes it dispatches `set-offer:change` on the document;
 *   assets/cart-looks.js and assets/pdp-looks.js re-rank on it.
 * - After an add from the product page's box it opens the cart drawer, as the page's own ADD TO
 *   CART does: Vitals repaints the drawer closed, and announces the add on the theme's cart-update.
 *
 * The two helpers at the top are pure and tested in Node (test/set-offer.test.js).
 */
(function (root) {
  // "offer:1138071|type:1|triggers:44426939858991|product:8040549023791:" → "8040549023791".
  function productIds(instanceIds) {
    const ids = new Set();
    for (const value of instanceIds) {
      for (const match of `${value ?? ""}`.matchAll(/product:(\d+)/g)) ids.add(match[1]);
    }
    return ids;
  }

  function titleKey(text) {
    return `${text ?? ""}`.replace(/\s+/g, " ").trim().toLowerCase();
  }

  const helpers = { productIds, titleKey };
  if (typeof module === "object" && module.exports) {
    module.exports = helpers;
    return;
  }

  const SLOT = "#bundle-product-bundles";
  const ROW = ".vitals-upsell-suggestions[data-suggestion-instance-id]";
  const SURFACES = "cart-drawer, cart-items";
  const BOX_ADD_WINDOW_MS = 10000;

  const offeredIds = (scope) =>
    productIds(Array.from(scope.querySelectorAll(ROW), (row) => row.dataset.suggestionInstanceId));

  // The box's pieces: its photos' alt text, and the list's titles once it is unfolded.
  const offeredTitles = () => {
    const box = document.querySelector(SLOT);
    if (!box) return new Set();
    const named = box.querySelectorAll('img[alt], [data-vtl-el="title"]');
    return new Set(Array.from(named, (el) => titleKey(el.alt || el.textContent)).filter(Boolean));
  };

  root.UMISetOffer = { ...helpers, offeredIds, offeredTitles };

  let last = "";
  let frame = 0;
  const check = () => {
    frame = 0;
    const surfaces = Array.from(document.querySelectorAll(SURFACES), (scope) => [...offeredIds(scope)].sort());
    const now = JSON.stringify([surfaces, [...offeredTitles()].sort()]);
    if (now === last) return;
    last = now;
    document.dispatchEvent(new CustomEvent("set-offer:change"));
  };
  const schedule = () => {
    frame ||= requestAnimationFrame(check);
  };

  let boxAdd = null;
  const openAfterBoxAdd = () => {
    if (!boxAdd || Date.now() - boxAdd.at > BOX_ADD_WINDOW_MS) return;
    const { button } = boxAdd;
    boxAdd = null;
    // After Vitals' repaint of the drawer, which follows its announcement.
    setTimeout(() => document.querySelector("cart-drawer")?.open?.(button), 0);
  };

  const start = () => {
    // These containers stay in the page; Vitals and the theme redraw what is inside them.
    for (const container of document.querySelectorAll(`${SURFACES}, ${SLOT}`)) {
      new MutationObserver(schedule).observe(container, { childList: true, subtree: true });
    }
    schedule();
    document.addEventListener(
      "click",
      (event) => {
        const button = event.target.closest?.(`${SLOT} [data-vtl-el="cta"]`);
        if (button) boxAdd = { at: Date.now(), button };
      },
      true,
    );
    if (typeof subscribe === "function") subscribe(PUB_SUB_EVENTS.cartUpdate, openAfterBoxAdd);
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", start);
  else start();
})(globalThis);
